var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "twitter",
  "use": "twitter-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 24 24\" id=\"twitter\">\r\n\t<path d=\"M23.5,4.9c-0.8,0.4-1.8,0.6-2.7,0.7c1-0.6,1.7-1.5,2.1-2.6c-0.9,0.5-1.9,0.9-3,1.1c-0.9-0.9-2.1-1.5-3.4-1.5\r\n\t\tc-2.6,0-4.7,2.1-4.7,4.7c0,0.4,0,0.7,0.1,1.1C7.9,8.3,4.4,6.4,2.1,3.5C1.7,4.2,1.5,5,1.5,5.9c0,1.6,0.8,3.1,2.1,3.9\r\n\t\tc-0.8,0-1.5-0.2-2.1-0.6c0,0,0,0,0,0.1c0,2.3,1.6,4.2,3.8,4.6C4.8,14,4.4,14.1,4,14.1c-0.3,0-0.6,0-0.9-0.1\r\n\t\tc0.6,1.9,2.3,3.2,4.4,3.3c-1.6,1.3-3.6,2-5.9,2c-0.4,0-0.8,0-1.1-0.1c2.1,1.3,4.6,2.1,7.2,2.1c8.7,0,13.4-7.2,13.4-13.4\r\n\t\tc0-0.2,0-0.4,0-0.6C22.1,6.6,22.9,5.8,23.5,4.9\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
module.exports = symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/social/twitter.svg
// module id = 554
// module chunks = 107818501498521